<div class="block--content block" id="main-content">
    <div class="block--wrap block">
        <rwidget-alert></rwidget-alert>
        <div class="ticket">
            <rwidget-validation-history></rwidget-validation-history>
        </div>
    </div>
</div>
